import { jsx as o } from "react/jsx-runtime";
import { useRef as c, useState as m, useEffect as _ } from "react";
import { c as r } from "../clsx-OuTLNxxd.js";
import { T as u, b as C, h as p, g as x, a as B, d as y, c as f, e as h } from "../Table-B_BMMuq4.js";
import '../GridTable.css';const N = "_gridTableWrapper_1gxi5_274", R = "_gridTable_1gxi5_274", W = "_gridTableRow_1gxi5_284", G = "_gridTableColumn_1gxi5_288", M = "_gridTableCaption_1gxi5_291", w = "_gridTableHeader_1gxi5_292", F = "_gridTableBody_1gxi5_293", H = "_gridTableFooter_1gxi5_294", E = "_gridTableCell_1gxi5_298", j = "_fullWidthMobile_1gxi5_301", v = "_hasMultipleTableBodies_1gxi5_310", O = "_mainColumn_1gxi5_345", i = {
  gridTableWrapper: N,
  gridTable: R,
  gridTableRow: W,
  gridTableColumn: G,
  gridTableCaption: M,
  gridTableHeader: w,
  gridTableBody: F,
  gridTableFooter: H,
  gridTableCell: E,
  fullWidthMobile: j,
  hasMultipleTableBodies: v,
  mainColumn: O
}, d = ({ children: e, className: l, label: a, mobileColumns: s, ...n }) => {
  const t = c(null), [b, T] = m(1);
  return _(() => {
    if (t.current) {
      const g = t.current.getElementsByClassName(i.gridTableBody);
      T(g.length);
    }
  }, []), /* @__PURE__ */ o(
    "div",
    {
      "aria-label": a,
      className: i.gridTableWrapper,
      "data-cxy-name": "grid-table",
      style: {
        "--gridWidth": b + 1,
        ...b === 1 ? { gridTemplateColumns: "auto" } : {},
        "--mobileColumns": s
      },
      children: /* @__PURE__ */ o(
        u,
        {
          className: r(i.gridTable, l, {
            [i.hasMultipleTableBodies]: b > 1
          }),
          ref: t,
          ...n,
          children: e
        }
      )
    }
  );
}, S = ({ children: e, className: l, ...a }) => /* @__PURE__ */ o(p, { className: r(i.gridTableRow, l), ...a, children: e }), k = ({ children: e, className: l, isMain: a, ...s }) => /* @__PURE__ */ o(
  y,
  {
    className: r(
      i.gridTableColumn,
      {
        [i.mainColumn]: a
      },
      l
    ),
    ...s,
    children: e
  }
), q = ({
  children: e,
  className: l,
  isFullWidthMobile: a,
  isMain: s,
  order: n,
  start: t,
  ...b
}) => /* @__PURE__ */ o(
  f,
  {
    className: r(
      i.gridTableCell,
      {
        [i.fullWidthMobile]: a,
        [i.mainColumn]: s
      },
      l
    ),
    style: { "--cellOrder": n, "--start": t },
    ...b,
    children: e
  }
), z = ({ children: e, className: l, ...a }) => /* @__PURE__ */ o(h, { ...a, className: r(i.gridTableFooter, l), children: e }), A = ({ children: e, className: l, ...a }) => /* @__PURE__ */ o(x, { ...a, className: r(i.gridTableHeader, l), children: e }), D = ({ children: e, className: l, ...a }) => /* @__PURE__ */ o(B, { className: r(i.gridTableBody, l), ...a, children: e }), I = ({ children: e, className: l, ...a }) => /* @__PURE__ */ o(C, { className: r(i.gridTableCaption, l), ...a, children: e });
d.Caption = I;
d.Row = S;
d.Head = A;
d.Body = D;
d.Column = k;
d.Cell = q;
d.Footer = z;
export {
  d as GridTable
};
